import type { Message } from '../services/api';

/** Only readable message text, never attachment URLs or encrypted envelopes. */
export function messageCopyText(message: Message | undefined, translation?: string): string | null {
  if (!message || message.type !== 'text' ||
      message.status === 'cancelled' || message.status === 'expired') return null;
  const text = translation || message.content;
  return text.trim() ? text : null;
}
